//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from '../config/store'

export default {
  components: {
    'component-sidebar': () => import(/* webpackChunkName: "components" */ '../components/Sidebar.vue'),
    'component-header': () => import(/* webpackChunkName: "components" */ '../components/Header.vue'),
    'component-footer': () => import(/* webpackChunkName: "modals" */ '../components/Footer.vue'),
  },
  
  props: {
    displayHeader: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    store
  }),

  watch: {
    'store.data.pagination.currentPage': function () {
      console.log('ok')
      if (!store.sidepanel.active) {
        this.scrollToTopHandler()
      }
    },
  },
  
  mounted () {
    this.$bus.$on('scrollToTop', this.scrollToTopHandler)
  },

  destroyed () {
    this.$bus.$off('scrollToTop', this.scrollToTopHandler)
  },
  
  methods: {
    scrollToTopHandler () {
      this.scrollToTop(document.getElementById('section'), 500)
    },

    onWindowEvent: function onWindowEvent () {
      store.heading.scrollY = this.$refs.content.scrollTop
      store.heading.isSticked = store.heading.scrollY >= store.heading.offsetTop
    },
  }
}
